<template>
  <div class="swiper-slide">
    <a :class="active ? 'active' : ''" href="javascript:void(0);" @click.prevent="activate" class="tag-btn">
      <div v-if="active" class="active-status"></div>
    {{name}}
    </a>
  </div>
</template>

<!--<button class="border-0 w-100 bg-transparent mb">
<i class="fa fa-angle-down text-center text-dark"></i>
</button>-->

<script setup>

import {onMounted} from "vue";

// eslint-disable-next-line no-undef
const props = defineProps({
  name: {
    type: String,
    default: "Category"
  },
  id: {
    type: String,
    default: "1"
  },
  active:{
    type: Boolean,
    default: false
  },
  setActive:{
    type: Function,
    default: () => {}
  }
})

onMounted(() => {

})

function activate(){
  props.setActive(props.id)
}
</script>

<style scoped>
.tag-group .tag-btn{
  padding: 6px 10px;
}

.tag-group .tag-btn.active{
  padding: 6px 10px;
}

.team-swiper-4 .swiper-slide{
  margin-left: 7px;
}
.active{
  background: transparent;
  border-color: var(--primary);
  color: var(--primary);
}
.tag-group .tag-btn:hover{
  background: transparent;
}
</style>